import {PlatformService} from './../../../services/platform';
import {StudiosService} from './../../../services/studios';
import {Component, trigger, state, style, transition, animate} from '@angular/core';
import {NavController, ModalController} from 'ionic-angular';
import {ClassPage} from '../shared/class/class';
import {SessionService} from '../../../services/session';
import {LocationsService} from '../../../services/locations';
import {BeautyClassesService} from '../../../services/beauty-classes';
import {BeautyStudiosService} from '../../../services/beauty-studios';

@Component({
  selector: 'beauty',
  templateUrl: 'beauty.html',
  animations: [
    trigger('panel', [
      state(
        'in',
        style({
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({
          transform: 'translateX(-100%)',
        }),
        animate(300),
      ]),
      transition('* => void', [
        animate(
          300,
          style({
            transform: 'translateX(100%)',
          })
        ),
      ]),
    ]),
  ],
})

export class BeautyPage {
  classPage = ClassPage;
  activePage = 'findBeautyPage'

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public classesService: BeautyClassesService,
    public studiosService: BeautyStudiosService,
    public sessionService: SessionService,
    public platformService: PlatformService,
    public locationsService: LocationsService
  ) {
  }

  //Changes date when clicking in the date picker
  changeDate(event) {
  }


  // Goes to a class in class list
  goToClass(classInfo) {
    if (classInfo.schedule.lesson_availability > classInfo.schedule.reservations) {
      this.navCtrl.push(this.classPage, {classInfo});
    }
  }

  // Loads next 30 clases
  loadNext(infiniteScroll) {
  }

  // Restarts classes and loads first 30 classes
  doRefresh(refresher?) {
    if (refresher) {
      refresher.complete();
    }
  }

  //Hides map when leaving
  ionViewWillLeave() {
  }

  //Shows map when entering
  ionViewWillEnter() {
  }

  ionViewDidEnter() {
  }

  ionViewDidLoad() {
    window['page'] = 'beautyPage'; // for GA
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/beauty/beauty.ts